"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSecurityCms = void 0;
var AccountSecurityCms = /** @class */ (function () {
    function AccountSecurityCms() {
        this.accountSecurityTitleLabel = 'Account security';
        this.editCTALabel = 'Edit';
        this.editAriaLabel = 'Edit account security';
        this.accountSecurityDescLabel = 'Let\'s create a passcode. You\'ll use it to confirm your identity ' +
            'when you contact us about your account. A passcode is different from a password and isn\'t ' +
            'used to sign in to your account. ';
        this.accountSecurityDescLabelSMB = 'Let’s create a strong passcode. You’ll use it to confirm your identity when you contact us about your account. A passcode is different from a password and isn’t used to sign in to your account.';
        this.accountSecurityDescLabelNewDtvBb = 'Let\'s create a passcode. You\'ll use it to confirm your identity ' +
            'when you contact us about <strong>internet</strong> account. A passcode is different from a password and isn\'t ' +
            'used to sign in to your account. ';
        this.messageHeading = 'Heads up: ';
        this.message = "The 4-digit passcode you create today will replace any existing wireless security\n    passcode you might already have on your account.";
        this.createPasscodeLabel = 'Create a 4-digit passcode';
        this.reEnterPasscodeLabel = 'Re-enter 4-digit passcode';
        this.addSecurityQuestionLabel = 'Just in case! Choose a security question and add an answer we ' +
            'can use to reset your passcode if you ever forget it.';
        this.addSecurityQuestionLabelSMB = "Choose a security question and add an answer so we can use it to reset your passcode if you forget it.\u201D";
        this.securityQuestionsLabel = 'Security question';
        this.securityAnswerLabel = 'Answer to security question';
        this.securityAnswerInputBoxPlaceHolder = 'Limit 80 characters';
        this.passcodeReadOnlyLabel = 'Passcode: ';
        this.securityQuestionReadOnlyLabel = 'Security question:';
        this.securityAnswerReadOnlyLabel = 'Security answer: ';
        this.inValidPassCodeErrTxt = 'Passcode is too short';
        this.inValidReenterPassCodeLabel = 'Re-enter your passcode';
        this.inValidReenterPassCodeLabelSMB = 'Confirm 4-digit passcode';
        this.reenterPasscodeNotMatchingErrTxt = 'Passcode does not match. Re-enter passcode';
        this.restrictNumbersErrTxt = 'Restrict to numbers only';
        this.accountSecurityPersistErrTxt = 'We are unable to process your request at this time. Please try again.';
        this.cancelButtonCTALabel = 'Cancel';
        this.addSecurityCTALabel = 'Add account security info';
        this.updateSecurityCTALabel = 'Update account security info';
    }
    return AccountSecurityCms;
}());
exports.AccountSecurityCms = AccountSecurityCms;
//# sourceMappingURL=accountsecurity.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/AccountSecurity/accountsecurity.cms.js
// module id = 2019
// module chunks = 8